export interface SiteConfiguration {
  name: string
  url: string
  description: string
}

export const SITE_DESCRIPTION_MAX_LENGTH = 155

export const SITE = {
  name: 'Insta Little Helper',
  url: 'https://insta.theanosmic.me',
  description: 'Crop, frame, split, preview, and export Instagram photos privately in your browser—your images never leave your device.',
} as const satisfies SiteConfiguration

export const SITE_TITLE = `${SITE.name} — crop, frame and split photos for Instagram, in your browser`

export function validateSite(site: SiteConfiguration = SITE): void {
  if (!site.name.trim()) throw new Error('Site name must not be empty')
  if (!site.description.trim() || site.description.length > SITE_DESCRIPTION_MAX_LENGTH) {
    throw new Error(`Site description must contain 1–${SITE_DESCRIPTION_MAX_LENGTH} characters`)
  }
  let url: URL
  try {
    url = new URL(site.url)
  } catch (error) {
    throw new Error('Site URL must be a valid absolute URL', { cause: error })
  }
  if (url.protocol !== 'https:' || url.pathname !== '/' || url.search || url.hash) {
    throw new Error('Site URL must be an HTTPS origin without a path, query, or fragment')
  }
}
